@if (files.length > 0) {
  <div class="files-list">
    @for (file of files; track file; let i = $index) {
      @if (fileDeleted.observers.length > 0) {
        <glxy-uploader-file [status]="file.status" [name]="file.name" [url]="file.url" (deleted)="deleteFile(file)" />
      } @else {
        <glxy-uploader-file [status]="file.status" [name]="file.name" [url]="file.url" />
      }
    }
  </div>
}
